import { defineComponent as _defineComponent } from 'vue'
import { inject, computed, Ref } from 'vue';
import { useRouter } from 'vue-router/composables';

import {
  ConclusionStep,
  ButtonPrimary,
  ContentDisplay,
  ListDisplay,
  HeadingDisplay
} from '@warrenbrasil/nebraska-web';

import { PortabilityRequestConclusionResponse } from '@/modules/trade/services/portability';


export default /*#__PURE__*/_defineComponent({
  __name: 'PortabilityRequestConclusion',
  setup(__props) {

const portabilityRequestConclusion = inject(
  'portabilityRequestConclusion'
) as Ref<PortabilityRequestConclusionResponse>;

const router = useRouter();

const handleClose = () => {
  router.push({ name: 'home' });
};

const custodianInitialChar = computed(() => {
  return portabilityRequestConclusion.value.portability.custodian.formatted[0];
});

return { __sfc: true,portabilityRequestConclusion, router, handleClose, custodianInitialChar, ConclusionStep, ButtonPrimary, ContentDisplay, ListDisplay, HeadingDisplay }
}

})